import { render, staticRenderFns } from "./GalleryFilters.vue?vue&type=template&id=2d06406c&"
import script from "./GalleryFilters.vue?vue&type=script&lang=js&"
export * from "./GalleryFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d06406c')) {
      api.createRecord('2d06406c', component.options)
    } else {
      api.reload('2d06406c', component.options)
    }
    module.hot.accept("./GalleryFilters.vue?vue&type=template&id=2d06406c&", function () {
      api.rerender('2d06406c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/gallery/GalleryFilters.vue"
export default component.exports